/*
 * /document-writer — клавиатура, вставка, автоформат, типографика.
 *
 *   · сочетания клавиш — как в Word (Ctrl+B/I/U, Ctrl+E/L/R/J, Ctrl+1/2/3/0,
 *     Ctrl+Enter — разрыв страницы, Ctrl+K — ссылка, Ctrl+[ / ] — кегль);
 *   · отмена — своя история (core.js), включая Ctrl+Z из контекстного меню и
 *     «встряхнуть» на телефоне (beforeinput historyUndo);
 *   · вставка из Word, Google Документов и браузера — через фильтр: остаётся
 *     смысл (заголовки, списки, таблицы, жирный, курсив, ссылки, картинки),
 *     уходит чужая вёрстка (шрифты сайта, фон, mso-стили). Ctrl+Shift+V —
 *     только текст;
 *   · автоформат в начале абзаца: «# » → заголовок, «- » → список, «1. » →
 *     нумерованный, «> » → цитата, «---» → линия. Ctrl+Z сразу после —
 *     возвращает набранные символы;
 *   · типографика при вводе: кавычки языка («ёлочки» / „лапки“ / “curly”),
 *     тире, многоточие, ©/®/™. Выключается в «Ещё»;
 *   · Tab: в таблице — следующая ячейка (в последней — новая строка); в
 *     шаблоне — следующее поле [в скобках]; в списке — уровень вложенности.
 */
(function () {
'use strict';
var DW = window.DW;
if (!DW) return;
var doc = DW.doc, C = DW.C, S = DW.S;

/* ── IME: пока идёт набор иероглифа/слога, документ не трогаем ───────────── */
doc.addEventListener('compositionstart', function () { S.composing = true; });
doc.addEventListener('compositionend', function () {
    S.composing = false;
    DW.afterChange('input');
    DW.history.schedule();
});

/* ── история ввода ─────────────────────────────────────────────────────── */
doc.addEventListener('beforeinput', function (e) {
    var it = e.inputType || '';
    if (it === 'historyUndo') { e.preventDefault(); DW.history.undo(); return; }
    if (it === 'historyRedo') { e.preventDefault(); DW.history.redo(); return; }
    // Граница слова — отдельный шаг отмены (как в Word: Ctrl+Z снимает слово, а
    // не весь абзац и не одну букву).
    if (it === 'insertParagraph' || it === 'insertLineBreak' || (it === 'insertText' && e.data === ' ')) {
        DW.history.commit();
    }
    if (it === 'insertText' && e.data && S.autoTypo && !S.composing) {
        if (typography(e)) return;
    }
});
doc.addEventListener('input', function (e) {
    var it = e.inputType || '';
    if (S.composing || e.isComposing) return;
    DW.afterChange('input');
    if (it === 'insertText' && e.data === ' ') autoformat();
    else if (it === 'insertParagraph') autoHr();
    DW.history.schedule();
});

/* ── сочетания клавиш ──────────────────────────────────────────────────── */
var ui = function (act, v) { if (DW.ui && DW.ui.act) DW.ui.act(act, v); };
doc.addEventListener('keydown', function (e) {
    if (e.isComposing || e.keyCode === 229) return;
    var mod = e.ctrlKey || e.metaKey, k = (e.key || '').toLowerCase();
    if (mod && !e.altKey) {
        var code = e.code || '';
        var map = {
            b: 'bold', i: 'italic', u: 'underline', k: 'link', e: ['align', 'center'], l: ['align', 'left'],
            r: ['align', 'right'], j: ['align', 'justify'], s: 'save', o: 'open', p: 'print', f: 'find', h: 'find',
            '1': ['style', 'h1'], '2': ['style', 'h2'], '3': ['style', 'h3'], '0': ['style', 'p'],
            '[': 'size-down', ']': 'size-up', '\\': 'clear'
        };
        // Раскладка не латинская (Ctrl+И): смотрим на физическую клавишу.
        var byCode = { KeyB: 'b', KeyI: 'i', KeyU: 'u', KeyK: 'k', KeyE: 'e', KeyL: 'l', KeyR: 'r', KeyJ: 'j', KeyS: 's', KeyO: 'o', KeyP: 'p', KeyF: 'f', KeyH: 'h', BracketLeft: '[', BracketRight: ']', Backslash: '\\', Digit1: '1', Digit2: '2', Digit3: '3', Digit0: '0', KeyZ: 'z', KeyY: 'y' };
        if (!map[k] && byCode[code]) k = byCode[code];
        if (k === 'z' && !e.shiftKey) { e.preventDefault(); DW.history.undo(); return; }
        if ((k === 'z' && e.shiftKey) || k === 'y') { e.preventDefault(); DW.history.redo(); return; }
        if (k === 'enter') { e.preventDefault(); DW.cmd.pageBreak(); return; }
        if (k === 'v' && e.shiftKey) { S.plainPaste = true; return; }
        if (k === 'a') return;
        if (k === 'x' && e.shiftKey) { e.preventDefault(); ui('strike'); return; }
        var m = map[k];
        if (m) {
            e.preventDefault();
            if (Array.isArray(m)) ui(m[0], m[1]); else ui(m);
            return;
        }
        if (e.key === '.' || code === 'Period') { e.preventDefault(); ui('sup'); return; }
        return;
    }
    if (e.key === 'Tab') {
        if (tabKey(e.shiftKey)) e.preventDefault();
        return;
    }
    if (e.key === 'Escape') { ui('escape'); return; }
    if (e.key === 'Backspace') { if (backspaceAtListOrQuote()) e.preventDefault(); }
});

/* Backspace в начале пустого пункта списка / цитаты — снять оформление, а не
   склеивать с предыдущим (как в Google Документах). */
function backspaceAtListOrQuote() {
    var r = DW.sel.range();
    if (!r || !r.collapsed) return false;
    var b = DW.curBlock();
    if (!b) return false;
    if (!atBlockStart(r, b)) return false;
    if (b.tagName === 'LI' && !b.textContent.replace(/[\u200b\s]/g, '')) {
        DW.cmd.run(function () { DW.cmd.exec(b.parentNode.tagName === 'OL' ? 'insertOrderedList' : 'insertUnorderedList'); }, 'list_off');
        return true;
    }
    if (b.tagName === 'BLOCKQUOTE' || /^H[1-4]$/.test(b.tagName)) {
        if (b.textContent.replace(/[\u200b\s]/g, '')) return false;
        DW.cmd.run(function () { DW.cmd.exec('formatBlock', '<p>'); }, 'style_off');
        return true;
    }
    return false;
}
function atBlockStart(r, b) {
    var pre = document.createRange();
    pre.selectNodeContents(b);
    pre.setEnd(r.startContainer, r.startOffset);
    return !pre.toString().replace(/[\u200b]/g, '');
}

/* ── Tab ───────────────────────────────────────────────────────────────── */
function tabKey(back) {
    var r = DW.sel.range(); if (!r) return false;
    var cell = (r.startContainer.nodeType === 1 ? r.startContainer : r.startContainer.parentNode).closest('td,th');
    if (cell && doc.contains(cell)) { moveCell(cell, back); return true; }
    if (jumpField(back)) return true;
    var b = DW.curBlock();
    if (b && b.closest('li')) { DW.cmd.indent(back ? -1 : 1); return true; }
    if (b && atBlockStart(r, b)) { DW.cmd.indent(back ? -1 : 1); return true; }
    if (!back) { DW.cmd.text('\t'); return true; }
    return false;
}
function placeIn(el, end) {
    var s = window.getSelection(), nr = document.createRange();
    nr.selectNodeContents(el);
    if (end !== undefined) nr.collapse(!end);
    s.removeAllRanges(); s.addRange(nr);
}
function moveCell(cell, back) {
    var row = cell.parentNode, table = cell.closest('table');
    var cells = Array.prototype.slice.call(table.querySelectorAll('td,th'));
    var i = cells.indexOf(cell);
    var next = cells[i + (back ? -1 : 1)];
    if (next) { placeIn(next); return; }
    if (back) return;
    DW.cmd.run(function () {
        var nr = row.cloneNode(true);
        Array.prototype.forEach.call(nr.cells, function (c) {
            var td = document.createElement('td');
            if (c.colSpan > 1) td.colSpan = c.colSpan;
            td.innerHTML = '<br>';
            nr.replaceChild(td, c);
        });
        row.parentNode.insertBefore(nr, row.nextSibling);
        placeIn(nr.cells[0], false);
    }, 'row_add');
}
/* Поля шаблона — текст в квадратных скобках: [ФИО], [Дата]. Tab выделяет
   следующее поле целиком — напечатанное заменит его. */
var FIELD_RE = /\[[^\[\]\n]{1,200}\]/g;
function jumpField(back) {
    var r = DW.sel.range(); if (!r) return false;
    var fields = DW.fields ? DW.fields() : [];
    if (!fields.length) return false;
    var target = null;
    for (var i = 0; i < fields.length; i++) {
        var f = fields[i];
        var cmp = f.compareBoundaryPoints(Range.START_TO_START, r);
        if (!back && (cmp > 0 || (cmp === 0 && r.collapsed))) { target = f; break; }
        if (back && f.compareBoundaryPoints(Range.END_TO_START, r) < 0) target = f;
    }
    if (!target && !back) target = fields[0];
    if (!target) return false;
    var s = window.getSelection(); s.removeAllRanges(); s.addRange(target.cloneRange());
    var el = target.startContainer.parentNode;
    if (DW.ui && DW.ui.reveal) DW.ui.reveal(target);
    return true;
}
DW.fields = function () {
    var out = [];
    var w = document.createTreeWalker(doc, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
        var v = n.nodeValue, m;
        FIELD_RE.lastIndex = 0;
        while ((m = FIELD_RE.exec(v))) {
            var r = document.createRange();
            r.setStart(n, m.index); r.setEnd(n, m.index + m[0].length);
            out.push(r);
        }
    }
    return out;
};

/* ── автоформат в начале абзаца ────────────────────────────────────────── */
function autoformat() {
    var r = DW.sel.range(); if (!r || !r.collapsed) return;
    var b = DW.curBlock(); if (!b || b.tagName !== 'P' || b.closest('li,td,th,blockquote')) return;
    var pre = document.createRange();
    pre.selectNodeContents(b);
    pre.setEnd(r.startContainer, r.startOffset);
    var txt = pre.toString().replace(/\u00a0/g, ' ');
    var m = /^(#{1,3}|[-*•–]|\d{1,3}[.)]|>) $/.exec(txt);
    if (!m) return;
    var mark = m[1];
    DW.history.commit();             // Ctrl+Z вернёт «# »
    DW.cmd.run(function () {
        pre.deleteContents();
        if (!b.textContent && !b.querySelector('br,img')) b.innerHTML = '<br>';
        var s = window.getSelection(), nr = document.createRange();
        nr.setStart(b, 0); nr.collapse(true); s.removeAllRanges(); s.addRange(nr);
        if (mark.charAt(0) === '#') DW.cmd.exec('formatBlock', '<h' + mark.length + '>');
        else if (mark === '>') DW.cmd.exec('formatBlock', '<blockquote>');
        else toList(b, /^\d/.test(mark) ? 'ol' : 'ul', /^\d/.test(mark) ? parseInt(mark, 10) : 1);
    }, 'autoformat');
    DW.track('autoformat', { mark: mark.charAt(0) === '#' ? 'h' : /^\d/.test(mark) ? 'ol' : mark === '>' ? 'quote' : 'ul' });
}
/* Абзац → пункт списка. Своими руками, а не командой браузера: команда на
   абзаце, из которого только что удалён маркер, оставляла список ВНУТРИ <p>.
   Соседний список того же вида продолжается. */
function toList(p, tag, start) {
    var prev = p.previousElementSibling;
    var li = document.createElement('li');
    while (p.firstChild) li.appendChild(p.firstChild);
    if (!li.firstChild) li.innerHTML = '<br>';
    var list;
    if (prev && prev.tagName === tag.toUpperCase()) { list = prev; list.appendChild(li); p.parentNode.removeChild(p); }
    else {
        list = document.createElement(tag);
        if (tag === 'ol' && start > 1) list.setAttribute('start', String(start));
        list.appendChild(li);
        p.parentNode.replaceChild(list, p);
    }
    var next = list.nextElementSibling;
    if (next && next.tagName === list.tagName) { while (next.firstChild) list.appendChild(next.firstChild); next.parentNode.removeChild(next); }
    var s = window.getSelection(), r = document.createRange();
    r.setStart(li, 0); r.collapse(true); s.removeAllRanges(); s.addRange(r);
}
function autoHr() {
    var r = DW.sel.range(); if (!r) return;
    var b = DW.curBlock(); if (!b) return;
    var prev = b.previousElementSibling;
    if (!prev || prev.tagName !== 'P' || !/^(-{3,}|_{3,}|\*{3,})$/.test(prev.textContent.trim())) return;
    DW.history.commit();
    DW.cmd.run(function () { prev.parentNode.replaceChild(document.createElement('hr'), prev); }, 'autoformat_hr');
}

/* ── типографика при вводе ─────────────────────────────────────────────── */
var QUOTES = {
    ru: ['«', '»', '„', '“'], uk: ['«', '»', '„', '“'], fr: ['«\u00a0', '\u00a0»', '“', '”'],
    de: ['„', '“', '‚', '‘'], en: ['“', '”', '‘', '’'], es: ['«', '»', '“', '”'], pt: ['“', '”', '‘', '’'],
    id: ['“', '”', '‘', '’'], ko: ['“', '”', '‘', '’'], ar: ['«', '»', '“', '”']
}[C.locale] || ['“', '”', '‘', '’'];
function charBefore(r, n) {
    var pre = document.createRange();
    var b = DW.curBlock() || doc;
    pre.selectNodeContents(b);
    try { pre.setEnd(r.startContainer, r.startOffset); } catch (e) { return ''; }
    var s = pre.toString();
    return s.slice(-(n || 1));
}
function typography(e) {
    var r = DW.sel.range(); if (!r) return false;
    var d = e.data, before = charBefore(r, 3);
    var out = null, del = 0;
    if (d === '"') {
        var open = !before || /[\s(\[{«„“‘\u00a0—–-]$/.test(before);
        // вложенные: если уже внутри «…» без закрывающей — внутренние
        var txt = charBefore(r, 400);
        var depth = (txt.split(QUOTES[0].trim()).length - 1) - (txt.split(QUOTES[1].trim()).length - 1);
        if (open) out = depth > 0 ? QUOTES[2] : QUOTES[0];
        else {
            var inner = (txt.split(QUOTES[2]).length - 1) > (txt.split(QUOTES[3]).length - 1);
            out = inner && depth > 0 ? QUOTES[3] : QUOTES[1];
        }
    } else if (d === "'" && C.locale === 'en') {
        out = (!before || /[\s(\[]$/.test(before)) ? '‘' : '’';
    } else if (d === '-' && /-$/.test(before) && !/--$/.test(before)) {
        out = '—'; del = 1;                                  // -- → —
    } else if (d === ' ' && / -$/.test(before)) {
        out = '\u00a0— '; del = 2;                           // « - » → « — »
    } else if (d === '.' && /\.\.$/.test(before)) {
        out = '…'; del = 2;
    } else if (d === ')' && /\((c|с|r|tm?)$/i.test(charBefore(r, 4))) {
        var tail = /\((c|с|r|tm?)$/i.exec(charBefore(r, 4))[0];
        var sym = { c: '©', 'с': '©', r: '®', tm: '™', t: null }[tail.slice(1).toLowerCase()];
        if (sym) { out = sym; del = tail.length; }
    }
    if (!out) return false;
    e.preventDefault();
    DW.history.commit();
    if (del) {
        var s = window.getSelection();
        for (var i = 0; i < del; i++) s.modify ? s.modify('extend', 'backward', 'character') : null;
    }
    DW.cmd.exec('insertText', out);
    DW.afterChange('typo');
    DW.history.schedule();
    return true;
}

/* «Типограф» по всему документу: кавычки, тире, неразрывные пробелы после
   коротких слов и перед тире, у чисел с единицами. Только текст — разметка не
   трогается. */
var SHORT = {
    ru: 'а|в|во|и|к|ко|о|об|обо|от|до|за|из|на|не|ни|но|по|с|со|у|я|ты|он|мы|вы|их|её|ее|его|же|ли|бы|то|да|для|при|про|без|над|под|что|как|или',
    uk: 'а|в|і|й|у|з|із|зі|до|за|на|не|ні|по|та|що|як|чи|або|для|від|при|про|без|над|під|це|ми|ви|він|вона|вони',
    en: 'a|an|the|of|in|on|at|to|by|for|and|or|but|is|it',
    de: 'der|die|das|ein|eine|und|in|im|an|am|zu|von|mit|bei',
    fr: 'le|la|les|un|une|de|du|des|et|à|en|au|aux',
    es: 'el|la|los|las|un|una|de|del|y|e|o|u|en|a|al',
    pt: 'o|a|os|as|um|uma|de|do|da|e|em|no|na|ao',
    id: 'di|ke|dan|yang|ini|itu',
    // в корейском и арабском такого правила набора нет: короткие служебные
    // слова либо пишутся слитно, либо не отрываются от строки
    ko: '',
    ar: ''
}[C.locale] || '';
function typographDocument() {
    var n = 0;
    DW.cmd.run(function () {
        var w = document.createTreeWalker(doc, NodeFilter.SHOW_TEXT, {
            acceptNode: function (x) { return x.parentNode.closest('code,pre') ? 2 : 1; }
        }), tn, nodes = [];
        while ((tn = w.nextNode())) nodes.push(tn);
        // кавычки считаем по блоку целиком, чтобы открывающая и закрывающая в
        // разных узлах (жирное слово в кавычках) встали верно
        var byBlock = new Map();
        nodes.forEach(function (x) {
            var b = DW.curBlock(x) || doc;
            if (!byBlock.has(b)) byBlock.set(b, []);
            byBlock.get(b).push(x);
        });
        byBlock.forEach(function (list) {
            var depth = 0, prevChar = '';
            list.forEach(function (x) {
                var v = x.nodeValue, out = '';
                for (var i = 0; i < v.length; i++) {
                    var ch = v.charAt(i);
                    if (ch === '"') {
                        var open = !prevChar || /[\s(\[{\u00a0—–-]/.test(prevChar);
                        if (open) { out += depth > 0 ? QUOTES[2] : QUOTES[0]; depth++; }
                        else { depth = Math.max(0, depth - 1); out += depth > 0 ? QUOTES[3] : QUOTES[1]; }
                        n++;
                    } else out += ch;
                    prevChar = ch;
                }
                var before = out;
                out = out
                    .replace(/(\S) - (?=\S)/g, '$1\u00a0— ')
                    .replace(/(\s)--(\s)/g, '$1—$2')
                    .replace(/\.\.\./g, '…')
                    .replace(/(\d) (%|₽|\$|€|руб\.|коп\.|кг|км|см|мм|г\.|гг\.|млн|млрд|тыс\.)/g, '$1\u00a0$2')
                    .replace(/(№|§) (?=\d)/g, '$1\u00a0');
                if (SHORT) {
                    var re = new RegExp('(^|[\\s(«„\u00a0])(' + SHORT + ') (?=\\S)', 'giu');
                    out = out.replace(re, function (m0, a, wd) { return a + wd + '\u00a0'; });
                }
                if (out !== v) { if (out !== before) n++; x.nodeValue = out; }
            });
        });
    }, 'typograph');
    return n;
}
DW.typograph = typographDocument;

/* ── вставка ───────────────────────────────────────────────────────────── */
doc.addEventListener('paste', function (e) {
    var cd = e.clipboardData;
    if (!cd) return;
    var files = [];
    for (var i = 0; i < (cd.files || []).length; i++) if (/^image\//.test(cd.files[i].type)) files.push(cd.files[i]);
    var html = cd.getData('text/html'), text = cd.getData('text/plain');
    if (files.length && !html) {
        e.preventDefault();
        files.reduce(function (p, f) { return p.then(function () { return DW.cmd.image(f); }); }, Promise.resolve());
        return;
    }
    e.preventDefault();
    var plain = S.plainPaste; S.plainPaste = false;
    if (!html || plain) { pasteText(text || ''); return; }
    var clean = sanitize(html);
    if (!clean.blocks) { pasteText(clean.text || text || ''); return; }
    DW.history.commit();
    DW.cmd.run(function () { insertFragment(clean.frag); }, 'paste');
    adoptPastedImages();
    DW.track('paste', { kind: clean.source || 'html', blocks: clean.blocks });
});
function pasteText(text) {
    text = String(text || '').replace(/\r\n?/g, '\n');
    if (!text) return;
    DW.history.commit();
    if (text.indexOf('\n') === -1) { DW.cmd.text(text); return; }
    var paras = text.split(/\n/);
    var frag = document.createDocumentFragment();
    paras.forEach(function (p) {
        var el = document.createElement('p');
        if (p) el.textContent = p; else el.innerHTML = '<br>';
        frag.appendChild(el);
    });
    DW.cmd.run(function () { insertFragment(frag); }, 'paste_text');
}
/* Вставить фрагмент из блоков: первый абзац фрагмента сливается с абзацем под
   кареткой, последний — с его хвостом, как в Word. */
function insertFragment(frag) {
    var r = DW.sel.restore(); if (!r) return;
    r.deleteContents();
    var kids = Array.prototype.slice.call(frag.childNodes);
    var allInline = kids.every(function (k) { return k.nodeType === 3 || !/^(P|H1|H2|H3|H4|UL|OL|TABLE|BLOCKQUOTE|HR|DIV|PRE)$/.test(k.tagName); });
    if (allInline || (kids.length === 1 && kids[0].tagName === 'P')) {
        var inner = document.createDocumentFragment();
        var src = allInline ? kids : Array.prototype.slice.call(kids[0].childNodes);
        var last = null;
        src.forEach(function (k) { last = k; inner.appendChild(k); });
        r.insertNode(inner);
        if (last) { var s = window.getSelection(), nr = document.createRange(); nr.setStartAfter(last); nr.collapse(true); s.removeAllRanges(); s.addRange(nr); }
        return;
    }
    var host = document.createElement('div');
    kids.forEach(function (k) { host.appendChild(k); });
    var lastEl = host.lastElementChild;
    DW.cmd.insertBlocks(host.innerHTML);
    void lastEl;
}
/* Картинки из вставки (data: или чужой адрес) — к нашим байтам; чужая картинка,
   которую сайт не отдаёт (CORS), остаётся ссылкой и в файл не попадёт — об этом
   скажет выгрузка. */
function adoptPastedImages() {
    doc.querySelectorAll('img').forEach(function (img) {
        var src = img.getAttribute('src') || '';
        if (DW.images.map[src]) return;
        if (/^data:image\//i.test(src)) {
            DW.images.blob(src).then(function (b) { if (b) { img.src = DW.images.add(b); DW.afterChange('img'); DW.history.schedule(); } });
        } else if (/^https?:/i.test(src)) {
            fetch(src, { mode: 'cors' }).then(function (r) { return r.ok ? r.blob() : null; }).then(function (b) {
                if (b && /^image\//.test(b.type)) { img.src = DW.images.add(b); DW.afterChange('img'); DW.history.schedule(); }
            }).catch(function () {});
        }
    });
}

/* Фильтр вставки. Белый список тегов и свойств; списки Word (MsoListParagraph +
   mso-list) собираются обратно в настоящие ul/ol. */
var KEEP_STYLE = ['font-weight', 'font-style', 'text-decoration', 'text-decoration-line', 'color', 'background-color', 'font-size', 'text-align', 'vertical-align'];
function sanitize(html) {
    var source = /urn:schemas-microsoft-com|class="?Mso/i.test(html) ? 'word' : /docs-internal-guid/.test(html) ? 'gdocs' : 'html';
    var d = new DOMParser().parseFromString(html, 'text/html');
    var body = d.body;
    body.querySelectorAll('script,style,meta,link,title,noscript,iframe,object,embed,svg,canvas,video,audio,button,input,select,textarea,form,o\\:p').forEach(function (x) { x.remove(); });
    if (source === 'word') wordLists(body);
    var frag = document.createDocumentFragment();
    var blocks = 0;
    function cleanInline(src, dst) {
        for (var c = src.firstChild; c; c = c.nextSibling) {
            if (c.nodeType === 3) { dst.appendChild(document.createTextNode(c.nodeValue.replace(/[\r\n]+/g, ' '))); continue; }
            if (c.nodeType !== 1) continue;
            var tg = c.tagName, el = null;
            if (/^(B|STRONG)$/.test(tg)) {
                var fw = c.style && c.style.fontWeight;
                el = (fw === 'normal' || fw === '400') ? document.createDocumentFragment() : document.createElement('b');
            } else if (/^(I|EM)$/.test(tg)) el = document.createElement('i');
            else if (tg === 'U') el = document.createElement('u');
            else if (/^(S|STRIKE|DEL)$/.test(tg)) el = document.createElement('s');
            else if (tg === 'SUB' || tg === 'SUP') el = document.createElement(tg.toLowerCase());
            else if (tg === 'CODE' || tg === 'KBD') el = document.createElement('code');
            else if (tg === 'BR') { dst.appendChild(document.createElement('br')); continue; }
            else if (tg === 'IMG') {
                var src2 = c.getAttribute('src') || '';
                if (/^(data:image\/|https?:|blob:)/i.test(src2)) { var im = document.createElement('img'); im.src = src2; im.alt = c.getAttribute('alt') || ''; dst.appendChild(im); }
                continue;
            } else if (tg === 'A') {
                var href = c.getAttribute('href') || '';
                if (/^(https?:|mailto:|tel:)/i.test(href)) { el = document.createElement('a'); el.setAttribute('href', href); }
                else el = document.createDocumentFragment();
            } else el = document.createElement('span');
            if (el.nodeType === 1 && c.style) copyStyle(c, el, false);
            cleanInline(c, el);
            if (el.nodeType === 1 && el.tagName === 'SPAN' && !el.getAttribute('style')) {
                var f2 = document.createDocumentFragment();
                while (el.firstChild) f2.appendChild(el.firstChild);
                el = f2;
            }
            dst.appendChild(el);
        }
    }
    function copyStyle(from, to, block) {
        var st = from.style; if (!st) return;
        KEEP_STYLE.forEach(function (p) {
            var v = st.getPropertyValue(p); if (!v) return;
            if (p === 'text-align' && !block) return;
            if (p === 'color' && /^(rgb\(0, 0, 0\)|#000000|black|windowtext|inherit|initial)$/i.test(v)) return;
            if (p === 'background-color' && /^(transparent|rgba\(0, 0, 0, 0\)|#ffffff|white|rgb\(255, 255, 255\)|inherit|initial)$/i.test(v)) return;
            if (p === 'font-weight' && !(parseInt(v, 10) >= 600 || v === 'bold')) return;
            if (p === 'font-style' && v !== 'italic') return;
            if (p === 'vertical-align' && !/^(super|sub)$/.test(v)) return;
            if (p === 'font-size') {
                var pt = /pt$/.test(v) ? parseFloat(v) : /px$/.test(v) ? parseFloat(v) * 0.75 : NaN;
                if (!pt || Math.abs(pt - S.set.size) < 0.6 || pt < 6 || pt > 96) return;
                v = (Math.round(pt * 2) / 2) + 'pt';
            }
            if (/^text-decoration/.test(p) && !/underline|line-through/.test(v)) return;
            to.style.setProperty(p, v);
        });
    }
    function block(src, tag) {
        var el = document.createElement(tag);
        copyStyle(src, el, true);
        cleanInline(src, el);
        if (!el.textContent.replace(/[\s\u00a0\u200b]/g, '') && !el.querySelector('img')) el.innerHTML = '<br>';
        blocks++;
        return el;
    }
    function walkBlocks(src, dst) {
        var inlineRun = null;
        for (var c = src.firstChild; c; c = c.nextSibling) {
            var tg = c.nodeType === 1 ? c.tagName : '';
            var isBlock = /^(P|DIV|H1|H2|H3|H4|H5|H6|UL|OL|TABLE|BLOCKQUOTE|HR|PRE|LI|SECTION|ARTICLE|HEADER|FOOTER|MAIN|ASIDE|FIGURE|TR|TBODY|THEAD|DL|DT|DD|ADDRESS|CENTER)$/.test(tg);
            if (!isBlock) {
                if (c.nodeType === 3 && !c.nodeValue.trim() && !inlineRun) continue;
                if (!inlineRun) { inlineRun = document.createElement('p'); dst.appendChild(inlineRun); blocks++; }
                var tmp = document.createElement('span');
                tmp.appendChild(c.cloneNode(true));
                cleanInline(tmp, inlineRun);
                continue;
            }
            inlineRun = null;
            if (/^H[1-6]$/.test(tg)) dst.appendChild(block(c, 'h' + Math.min(4, +tg.charAt(1))));
            else if (tg === 'P' || tg === 'DT' || tg === 'DD' || tg === 'ADDRESS' || tg === 'CENTER') dst.appendChild(block(c, 'p'));
            else if (tg === 'PRE') { var pre = document.createElement('p'); var code = document.createElement('code'); code.textContent = c.textContent; pre.appendChild(code); dst.appendChild(pre); blocks++; }
            else if (tg === 'BLOCKQUOTE') { dst.appendChild(block(c, 'blockquote')); }
            else if (tg === 'HR') { dst.appendChild(document.createElement('hr')); blocks++; }
            else if (tg === 'UL' || tg === 'OL') dst.appendChild(list(c));
            else if (tg === 'TABLE') { var tb = table(c); if (tb) dst.appendChild(tb); }
            else if (tg === 'LI') { var ul = document.createElement('ul'); ul.appendChild(listItem(c)); dst.appendChild(ul); }
            else {
                // div/section: блок-обёртка — смотрим внутрь
                var hasBlock = c.querySelector && c.querySelector('p,div,h1,h2,h3,h4,h5,h6,ul,ol,table,blockquote,hr,pre,li');
                if (hasBlock) walkBlocks(c, dst); else dst.appendChild(block(c, 'p'));
            }
        }
    }
    function listItem(li) {
        var el = document.createElement('li');
        var nested = [];
        for (var c = li.firstChild; c; c = c.nextSibling) {
            if (c.nodeType === 1 && (c.tagName === 'UL' || c.tagName === 'OL')) nested.push(c);
        }
        var tmp = li.cloneNode(true);
        tmp.querySelectorAll('ul,ol').forEach(function (x) { x.remove(); });
        // абзацы внутри пункта → текст с переносами
        tmp.querySelectorAll('p,div').forEach(function (p, i) { if (i) p.insertBefore(document.createElement('br'), p.firstChild); });
        cleanInline(tmp, el);
        if (!el.textContent.trim() && !el.querySelector('img')) el.innerHTML = '<br>';
        nested.forEach(function (n) { el.appendChild(list(n)); });
        return el;
    }
    function list(src) {
        var el = document.createElement(src.tagName.toLowerCase());
        if (src.tagName === 'OL' && src.getAttribute('start')) el.setAttribute('start', src.getAttribute('start'));
        for (var c = src.firstChild; c; c = c.nextSibling) {
            if (c.nodeType !== 1) continue;
            if (c.tagName === 'LI') el.appendChild(listItem(c));
            else if (c.tagName === 'UL' || c.tagName === 'OL') {
                var lastLi = el.lastElementChild || el.appendChild(document.createElement('li'));
                lastLi.appendChild(list(c));
            }
        }
        blocks++;
        return el;
    }
    function table(src) {
        var rows = src.querySelectorAll('tr');
        if (!rows.length) return null;
        var t = document.createElement('table'), tb = document.createElement('tbody');
        t.appendChild(tb);
        rows.forEach(function (tr) {
            if (tr.closest('table') !== src) return;
            var r = document.createElement('tr');
            Array.prototype.forEach.call(tr.cells, function (cell) {
                var c = document.createElement(cell.tagName === 'TH' ? 'th' : 'td');
                if (cell.colSpan > 1) c.colSpan = cell.colSpan;
                if (cell.rowSpan > 1) c.rowSpan = cell.rowSpan;
                var tmp = cell.cloneNode(true);
                tmp.querySelectorAll('p,div').forEach(function (p, i) { if (i) p.insertBefore(document.createElement('br'), p.firstChild); });
                cleanInline(tmp, c);
                if (!c.textContent.trim() && !c.querySelector('img')) c.innerHTML = '<br>';
                r.appendChild(c);
            });
            tb.appendChild(r);
        });
        blocks++;
        return t;
    }
    walkBlocks(body, frag);
    var text = body.textContent || '';
    return { frag: frag, blocks: blocks, text: text, source: source };
}
/* Word кладёт пункты списка абзацами с mso-list и маркером в span
   mso-list:Ignore. Собираем их в ul/ol по уровню. */
function wordLists(body) {
    var paras = body.querySelectorAll('p');
    var stack = [], lastP = null;
    paras.forEach(function (p) {
        var style = p.getAttribute('style') || '';
        var m = /mso-list:\s*l(\d+)\s+level(\d+)/i.exec(style);
        if (!m) { stack = []; return; }
        var level = +m[2];
        var ign = p.querySelector('[style*="mso-list:Ignore"],[style*="mso-list: Ignore"]');
        var marker = ign ? ign.textContent.trim() : '';
        if (ign) ign.remove();
        var ordered = /^(\(?[0-9a-zA-Zа-яА-Я]{1,3}[.)])$/.test(marker);
        var li = document.createElement('li');
        while (p.firstChild) li.appendChild(p.firstChild);
        while (stack.length > level) stack.pop();
        if (!stack.length || stack.length < level) {
            var list = document.createElement(ordered ? 'ol' : 'ul');
            if (!stack.length) p.parentNode.insertBefore(list, p);
            else { var host = stack[stack.length - 1].lastElementChild || stack[stack.length - 1]; host.appendChild(list); }
            stack.push(list);
        }
        stack[stack.length - 1].appendChild(li);
        p.remove();
        lastP = li;
    });
    void lastP;
}

/* ── перетаскивание файлов на лист ─────────────────────────────────────── */
doc.addEventListener('dragover', function (e) {
    if (e.dataTransfer && Array.prototype.indexOf.call(e.dataTransfer.types || [], 'Files') !== -1) e.preventDefault();
});
doc.addEventListener('drop', function (e) {
    var files = e.dataTransfer && e.dataTransfer.files;
    if (!files || !files.length) return;
    e.preventDefault();
    var f = files[0];
    if (/^image\//.test(f.type)) {
        // каретка — туда, куда бросили
        var pos = document.caretPositionFromPoint ? document.caretPositionFromPoint(e.clientX, e.clientY) : null;
        var rng = pos ? (function () { var r = document.createRange(); r.setStart(pos.offsetNode, pos.offset); return r; })()
            : (document.caretRangeFromPoint ? document.caretRangeFromPoint(e.clientX, e.clientY) : null);
        if (rng && doc.contains(rng.startContainer)) { var s = window.getSelection(); s.removeAllRanges(); s.addRange(rng); }
        Array.prototype.reduce.call(files, function (p, x) { return /^image\//.test(x.type) ? p.then(function () { return DW.cmd.image(x); }) : p; }, Promise.resolve());
        return;
    }
    if (DW.ui && DW.ui.openFile) DW.ui.openFile(f);
});

DW.input = { sanitize: sanitize, insertFragment: insertFragment, pasteText: pasteText };
})();
